import { AdminPanelHeader, SideBar, DashBoardHeader } from 'components';
import useApiManager from 'networking/ApiManager';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { filters, addIconWhite } from 'res/images';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';
import { CommonAlert, Pagination, PostHeader, Loader, EmptyView, FilterChips, CoreInputBox } from 'whealth-core-web/components';
import FilterModal from '../components/FilterModal';
import SearchBox from 'whealth-core-web/components/common/SearchBox';
import { checkObjectLength, genrageFilterParams, titlizeString } from 'whealth-core-web/components/Helper';
import ShowPatientList from './patient/ShowPatientList';
import PatientNotes from './patient/PatientNotes';
import PatientConversion from './patient/PatientConversion';
import { useFilter } from 'whealth-core-web/components/FilterContext';
import { user } from 'whealth-core-web/assets/images';
import { set } from 'rsuite/esm/utils/dateUtils';

function Patient() {
  const ApiClient = useApiManager();
  const location = useLocation();
  const navigation = useNavigate();
  // const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  // const [click, setClick] = useState('');
  const [status, setStatus] = useState({ link: '' });
  const [isClearVal, setIsClearVal] = useState(false);
  const [data, setData] = useState('');
  const [hideEmpty, setHideEmpty] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [usersCount, setUsersCount] = useState([]);
  const [countData, setCountData] = useState({});
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // const [filterData, setFilterData] = useState({ active_patients: 'true' });
  const { filterData, setFilterData } = useFilter();
  const [clearFiltersData, setClearFilterData] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const value = useRef('');
  let userData = useGetLoginUserDataQuery()?.data?.data || {};
  const [showPatientNotes, setShowPatientNotes] = useState(false);
  const [showPatientConversion, setShowPatientConversion] = useState(false);
  const [patientCoversionId, setPatientCoversionId] = useState('');

  const [conversionKey, setConversionKey] = useState('');
  const [patientId, setPatientId] = useState('');
  const [content, setContent] = useState('');
  const [titleReal, setTitleReal] = useState('');
  const [noteCategory, setNoteCategory] = useState('');
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    if (searchStr.length == 0) {
      getAdminProfiles();
      getAdminProfilesCount();
    }
  }, [status, currentPage, filterData, searchStr]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchStr.length > 2) {
        getAdminProfiles();
        getAdminProfilesCount();
      } else {
        // getCounts();
      }
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, [searchStr, status, currentPage, filterData]);

  useEffect(() => {
    getCounts();
  }, [countData]);

  const getCounts = () => {
    let newArr = Object.keys(countData).reverse((a, b) => a - b);
    let newData = [];
    newArr.map((item) => {
      let newObj = countData[item];
      let title = `${item} (${countData[item].count || 0})`;
      title = titlizeString(title);
      newObj.title = title;
      newObj.link = countData[item].uuid || '';
      newData.push(newObj);
    });

    setUsersCount(newData.sort((a, b) => a.order - b.order));
  };

  // useEffect(() => {
  //   let tempFIlterData = {};
  //   for (let [key, value] of searchParams.entries()) {
  //     value = decodeURI(value);
  //     switch (value) {
  //       case 'true':
  //         tempFIlterData[key] = true;
  //         continue;
  //       case 'false':
  //         tempFIlterData[key] = false;
  //         continue;
  //       case 'null':
  //         tempFIlterData[key] = null;
  //         continue;
  //       case 'undefined':
  //         tempFIlterData[key] = undefined;
  //         continue;
  //     }

  //     if (key === 'care_manager_lead' || key === 'sub_status') {
  //       if (value) {
  //         tempFIlterData[key] = value.split('|');
  //       }
  //     } else if (key === 'prescriptionDate' || key === 'pmsDate' || key === 'pmsConsultDate') {
  //       tempFIlterData[key] = value?.split('|')?.map((date) => new Date(date).toString());
  //     } else {
  //       tempFIlterData[key] = value;
  //     }
  //   }
  //   setFilterData(tempFIlterData);
  // }, [searchParams]);

  // useEffect(() => {
  // let updatedSearchParams = new URLSearchParams(searchParams.toString());
  // if (Object.keys(filterData)?.length === 0) {
  //   navigation(`?`, { replace: true });
  //   console.log('***** searchParams 1*****', { filterData });
  //   // return;
  // } else {
  //   let excludeKeys = ['active_patients', 'tag_ids', 'tags_data', 'tag_SelectedData', 'source'];
  //   for (let key in filterData) {
  //     if (excludeKeys.includes(key)) {
  //       continue;
  //     }
  //     if (Array.isArray(filterData[key]) && filterData[key].length > 0) {
  //       updatedSearchParams.set(key, encodeURI(filterData[key].join('|')));
  //     } else {
  //       updatedSearchParams.set(key, encodeURI(filterData[key]));
  //     }
  //   }
  //   navigation(`?${updatedSearchParams.toString()}`, { replace: true });
  //   console.log('***** searchParams 2*****', { filterData });
  // }
  // }, [filterData]);

  useEffect(() => {
    if (location?.state?.showAlert) {
      setIsShowAlert(location.state.showAlert);
    }
  }, [location?.state?.showAlert]);

  const createFilterParams = (data, defaultObj) => {
    let ignoreKeys = ['author_data', 'admin_data', 'date', 'tags_data', 'pmsDate', 'pmsConsultDate','prcDate', 'prescriptionDate'];
    let filterParams = { ...data };
    if (defaultObj) {
      filterParams = { ...filterParams, ...defaultObj };
    }
    genrageFilterParams(data, filterParams, ignoreKeys);
    return filterParams;
  };

  const getAdminProfilesCount = () => {
    let prevFilterData = JSON.parse(JSON.stringify(filterData));

    // Check if care_manager_lead is an array before joining
    if (Array.isArray(prevFilterData?.care_manager_lead)) {
      prevFilterData.care_manager_lead = prevFilterData.care_manager_lead.join(',');
    }
    if (Array.isArray(prevFilterData?.clinic)) {
      prevFilterData.clinic = prevFilterData.clinic.join(',');
    }
    if (Array.isArray(prevFilterData?.doctor)) {
      prevFilterData.doctor = prevFilterData.doctor.join(',');
    }
    // Check if sub_status is an array before joining
    if (Array.isArray(prevFilterData?.sub_status)) {
      prevFilterData.sub_status = prevFilterData?.sub_status?.join(',');
    }
    let qryParams = createFilterParams(prevFilterData);
    qryParams.search_str = searchStr;
    ApiClient.getPatientCount(qryParams)
      .then((res) => {
        if (value.current === qryParams.search_str) {
          setCountData(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAdminProfiles = () => {
    let defaultObj = {
      status: status.link,
      page: currentPage,
      page_size: '20',
    };
    let prevFilterData = JSON.parse(JSON.stringify(filterData));

    // Check if care_manager_lead is an array before joining
    if (Array.isArray(prevFilterData?.care_manager_lead)) {
      prevFilterData.care_manager_lead = prevFilterData.care_manager_lead.join(',');
    }
    if (Array.isArray(prevFilterData?.clinic)) {
      prevFilterData.clinic = prevFilterData.clinic.join(',');
    }
    if (Array.isArray(prevFilterData?.doctor)) {
      prevFilterData.doctor = prevFilterData.doctor.join(',');
    }
    // Check if sub_status is an array before joining
    if (Array.isArray(prevFilterData?.sub_status)) {
      prevFilterData.sub_status = prevFilterData?.sub_status?.join(',');
    }

    let qryParams = createFilterParams(prevFilterData, defaultObj);
    qryParams.search_str = searchStr;
    setIsLoading(true);
    ApiClient.getPatients(qryParams)
      .then((res) => {
        // if (value.current === qryParams.search_str) {
        setTotalPages(res.headers['total-pages']);
        setData(res.data);
        setIsLoading(false);
        setHideEmpty(false);
        // }
      })
      .catch((err) => {
        setHideEmpty(false);
        setIsLoading(false);
        console.log(err);
      });
  };
  // const sideBar = useMemo(() => {
  //   return <SideBar />;
  // }, []);
  const headerData = [
    {
      title: 'Add Patient ',
      icon: addIconWhite,
      status: true,
      onClick: () => navigation('/patient/new'),
      style: { height: '24px', fontSize: '0.70rem' },
    },
  ];

  const leftSideData = [
    {
      title: 'Apply Filter',
      className: 'themeColor boldFont applyFilterBtn',
      showBtn: true,
      icon: filters,
      onClick: () => {
        setShowFilter(true);
      },
      style: { height: '24px', fontSize: '12px' },
    },
  ];

  const addExtraParm = () => {
    let startDate = new Date();
    let endDate = new Date();
    if (filterData.pmsConsultDate) {
      let newFilterData = { ...filterData };
      delete newFilterData.pmsConsultDate;
      setFilterData({ ...newFilterData });
    } else {
      setFilterData({ ...filterData, pmsConsultDate: [startDate, endDate] });
    }
  };

  const activePatientOnClick = () => {
    if (filterData.active_patients) {
      let newFilterData = { ...filterData };
      delete newFilterData.active_patients;
      setFilterData({ ...newFilterData });
    } else {
      setFilterData({ ...filterData, active_patients: 'true' });
    }
  };

  const clearFilters = () => {
    setFilterData(new Object());
    setClearFilterData(!clearFiltersData);
  };

  const renderFilterChips = useMemo(() => {
    const ignoreKeys = ['tag_ids', 'tags_data', 'category_ids', 'author_ids', 'active_patients'];

    if (checkObjectLength(filterData, ignoreKeys)) {
      return (
        <div className={filterData ? 'mt-3' : ''}>
          <FilterChips clearData={clearFilters} setData={setFilterData} data={filterData} />
        </div>
      );
    } else {
      if (Object.keys(filterData).length > 0 && !filterData.today_date && !filterData.active_patients) {
        clearFilters();
      }
      return;
    }
  }, [filterData]);

  const renderDashBoardHeader = useMemo(() => {
    return (
      <DashBoardHeader
        filterData={filterData}
        onClick={addExtraParm}
        activePatientOnclick={activePatientOnClick}
        patienLeftbtn
        activePatientBtn
        leftData={leftSideData}
        data={userData.read_only || (userData.role == 'doctor' && userData?.department?.id != 2) ? null : headerData}
        placeholder='Select Order'
      />
    );
  }, [filterData, userData]);

  const renderPostHeader = useMemo(
    () => (
      <PostHeader
        thisPage='patient'
        postLinks={usersCount}
        onClickHandle={(data) => {
          setCurrentPage(1);
          setStatus(data);
        }}
      />
    ),
    [usersCount]
  );
  const renderSearchBox = () => {
    return (
      <div className='w-100'>
        <CoreInputBox
          placeholder='Search a patient by name or mobile number'
          setValue={(val) => {
            setCurrentPage(1);
            value.current = val;
            setSearchStr(val);
          }}
          value={searchStr}
          inputStyle={{ height: '24px', fontSize: '0.75rem' }}
        />
      </div>
    );
  };

  const showPatient = () => (
    <div className='teamHeader stickyHeader'>
      <div className='headerFilesRow'>
        <AdminPanelHeader searchBox={renderSearchBox()} />
        {renderDashBoardHeader}
      </div>
      <div className='hrLine' />
      <div className='teamBody1'>
        <div className=''>
          <CommonAlert redux='patientCreate' />
        </div>
        {isShowAlert && (
          <div className='mt-3'>
            <CommonAlert isShowAlert={isShowAlert} setIsShowAlert={setIsShowAlert} />
          </div>
        )}

        {renderPostHeader}
        {renderFilterChips}
      </div>
    </div>
  );

  const renderEmptyView = () => {
    return <EmptyView hide={isLoading || hideEmpty} title='No data found' />;
  };

  const showPatients = useMemo(
    () => (
      <ShowPatientList
        searchStr={searchStr}
        isClearVal={isClearVal}
        setIsClearVal={setIsClearVal}
        data={data}
        setPatientId={setPatientId}
        setShowPatientNotes={setShowPatientNotes}
        showPatientNotes={showPatientNotes}
        renderStatusChange
        getAdminProfiles={getAdminProfiles}
        setConversionKey={setConversionKey}
        assignTeam
        setContent={setContent}
        setTitleReal={setTitleReal}
        setNoteCategory={setNoteCategory}
        patientId={patientId}
        setShowPatientConversion={setShowPatientConversion}
        showPatientConversion={showPatientConversion}
        patientCoversionId={patientCoversionId}
        setPatientCoversionId={setPatientCoversionId}
      />
    ),
    [data]
  );

  const patientBody = () => {
    return (
      <>
        {showPatient()}
        <div className='usersList wrapperContent' style={{ marginTop: '16px' }}>
          {data?.length > 0 ? showPatients : renderEmptyView()}
          <div className='d-flex justify-content-end mb-4'>
            <Pagination
              data={data}
              length={countData?.all_patients?.count}
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              page='patient'
            />
          </div>
        </div>
      </>
    );
  };

  const getFilterData = (data) => {
    setFilterData(data);
    setCurrentPage(1);
  };

  const showFilters = useCallback(() => {
    return (
      <FilterModal
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        clearFiltersData={clearFiltersData}
        setClearFilterData={setClearFilterData}
        filter='patient'
        getData={getFilterData}
        data={filterData}
        userData={userData}
      />
    );
  }, [clearFiltersData, filterData, showFilter]);
  return (
    <div className='wrapper'>
      {/* {sideBar} */}
      {patientBody()}
      <Loader show={isLoading} />
      {showFilters()}
      {/* {showPatientNotesDetails()} */}
      <PatientNotes
        content={content}
        setContent={setContent}
        titleReal={titleReal}
        setTitleReal={setTitleReal}
        noteCategory={noteCategory}
        setNoteCategory={setNoteCategory}
        patientId={patientId}
        showPatientNotes={showPatientNotes}
      />
      <PatientConversion
        isClearVal={isClearVal}
        setIsClearVal={setIsClearVal}
        content={content}
        // getAdminProfiles={getAdminProfiles}
        setContent={setContent}
        titleReal={titleReal}
        setTitleReal={setTitleReal}
        noteCategory={noteCategory}
        setNoteCategory={setNoteCategory}
        patientId={patientCoversionId}
      />
    </div>
  );
}

export default Patient;
